
import React from "react";
import errorImage from "../image/Error-page.png";
import { Box, Button, Container, Grid, Typography } from "@mui/material";

function NotFound() {
  return (
    <Container maxWidth="xl" sx={{ height: "100vh" }} title="Page Not Found">
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Box>
          <Grid
            container
            spacing={1}
            alignItems="center"
            justifyContent="center"
            style={{ height: "50vh" }}
          >
            <Grid item xs={11}>
              <Box>
                <Typography variant="h3">Something went wrong</Typography>
                <p>
                  <br />
                  The specified file was not found on this website. Please check
                  the URL for mistakes and try again.
                  <br />
                  <br />
                </p>
                <Box>
                  <Button variant="contained" href="/signin">
                    Get back to Home
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box>
          <Box mt={10}>
            <img
              width="100%"
              height="100%"
              style={{
                objectFit: "cover",
                objectPosition: "center",
              }}
              src={errorImage}
              alt=""
            />
          </Box>
        </Box>
      </Grid>
    </Container>
  );
}

export default NotFound;
